module.exports = __webpack_public_path__ + "img/20200104131443198.0dfc10d0.jpg";